import { render, staticRenderFns } from "./fixedBox.vue?vue&type=template&id=c3fcc1a0&scoped=true"
import script from "./fixedBox.vue?vue&type=script&lang=js"
export * from "./fixedBox.vue?vue&type=script&lang=js"
import style0 from "./fixedBox.vue?vue&type=style&index=0&id=c3fcc1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fcc1a0",
  null
  
)

export default component.exports